import React from 'react'
import DataNotFound from '../../Images/data-not-found.png'
import './Data_NotFound.css'

export default function Data_NotFound() {
  return (
    <div className='notfound-container'>
      <img src={DataNotFound} alt='Data Not Found'/>
      <p>Data Not Found</p>
    </div>
  )
}
